(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["br-banner1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('br-campaigns')) {
    customElements.define('br-campaigns', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.track = this.querySelector('.br-campaigns__track');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-index]'));
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.active = 0;
        if (this.slides.length < 2) return;
        this.classList.add('is-enhanced');
        this.querySelector('.br-campaigns__controls').hidden = false;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.show(this.active + Number(button.dataset.step)), { signal }));
        this.dots.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.index)), { signal }));
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        this.addEventListener('touchstart', event => {
          if (this.mobile.matches) return;
          this.startX = event.changedTouches[0].clientX;
          this.startY = event.changedTouches[0].clientY;
        }, { passive: true, signal });
        this.addEventListener('touchend', event => {
          if (this.mobile.matches || this.startX == null) return;
          const dx = event.changedTouches[0].clientX - this.startX;
          const dy = event.changedTouches[0].clientY - this.startY;
          this.startX = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.active + (dx < 0 ? 1 : -1));
        }, { passive: true, signal });
        this.track.addEventListener('scroll', () => {
          if (!this.mobile.matches) return;
          if (!this.scrollFrame) {
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.updateActive(this.nearestSlide());
            });
          }
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.updateActive(this.nearestSlide(), true), 150);
        }, { passive: true, signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, { signal });
        this.mobile.addEventListener('change', () => this.syncLayout(), { signal });
        this.resizeObserver = new ResizeObserver(() => this.syncLayout());
        this.resizeObserver.observe(this.track);
        this.syncLayout();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.scrollTimer);
        this.ready = false;
      }
      nearestSlide() {
        return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      }
      syncLayout() {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        clearTimeout(this.scrollTimer);
        this.updateActive(this.active);
        this.track.scrollLeft = this.mobile.matches ? this.active * this.track.clientWidth : 0;
      }
      updateActive(index, announce = false) {
        this.active = index;
        this.slides.forEach((slide, i) => {
          slide.hidden = !this.mobile.matches && i !== index;
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        if (announce) this.querySelector('[data-announcement]').textContent = this.slides[index].getAttribute('aria-label');
      }
      show(index, announce = true) {
        const next = (index + this.slides.length) % this.slides.length;
        if (this.mobile.matches) {
          const smooth = announce && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({ left: next * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
          if (!smooth) this.updateActive(next, announce);
        } else {
          this.updateActive(next, announce);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  if (!customElements.get('bebe-room-cart-invoice')) {
    customElements.define('bebe-room-cart-invoice', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.type = this.querySelector('select');
        this.fields = this.querySelector('fieldset');
        this.status = this.querySelector('[data-invoice-status]');
        this.queue = Promise.resolve();
        this.sync = () => {
          const invoice = this.type.value === 'Factura';
          this.fields.hidden = !invoice;
          this.fields.disabled = !invoice;
          document.documentElement.classList.toggle('bebe-room-invoice-active', invoice);
        };
        this.addEventListener('change', () => { this.sync(); this.save(); });
        this.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.save(), 500); });
        this.querySelector('[data-invoice-save]').addEventListener('click', () => {
          const invalid = this.type.value === 'Factura' && [...this.querySelectorAll('input')].find(input => !input.checkValidity());
          if (invalid) { invalid.reportValidity(); return; }
          this.save();
        });
        this.sync();
        const params = new URLSearchParams(location.search);
        if (params.get('factura') === '1') {
          this.type.value = 'Factura';
          this.sync();
          this.save();
          params.delete('factura');
          history.replaceState(null, '', location.pathname + (params.size ? '?' + params : '') + '#bebe-room-invoice');
          requestAnimationFrame(() => { this.scrollIntoView({block: 'start'}); this.querySelector('h2').focus({preventScroll: true}); });
        }
        const form = document.getElementById('cart');
        form.addEventListener('submit', async event => {
          if (this.submitting) return;
          event.preventDefault();
          const submitter = event.submitter;
          if (await this.save()) {
            this.submitting = true;
            form.requestSubmit(submitter || undefined);
            this.submitting = false;
          }
        });
      }
      save() {
        clearTimeout(this.timer);
        const attributes = {};
        this.querySelectorAll('[name^="attributes["]').forEach(input => {
          const key = input.name.slice(11, -1);
          attributes[key] = input === this.type || this.type.value === 'Factura' ? input.value.trim() : '';
        });
        this.status.textContent = this.dataset.saving;
        const job = this.queue.catch(() => {}).then(async () => {
          try {
            const response = await fetch(this.dataset.updateUrl, {method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({attributes})});
            if (!response.ok) throw new Error('cart-update');
            this.status.textContent = this.dataset.saved;
            return true;
          } catch (error) {
            this.status.textContent = this.dataset.error;
            return false;
          }
        });
        this.queue = job;
        return job;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function cleanProductFacts(root) {
    const factLabels = [
      'Material:',
      'Dimensiones:',
      'Peso:',
      'Edad recomendada:',
      'Cantidad de piezas:',
      'Contenido:',
      'Beneficios principales:',
      'Seguridad:'
    ];
    const emptyLabels = [
      'Dimensiones:',
      'Edad recomendada:',
      'Cantidad de piezas:',
      'Contenido:',
      'Beneficios principales:',
      'Seguridad:'
    ];
    root.querySelectorAll('[data-product-description] li').forEach((item) => {
      const text = item.textContent.replace(/\u00a0/g, ' ').trim();
      if (emptyLabels.includes(text)) item.hidden = true;
    });
    root.querySelectorAll('[data-product-description] p').forEach((paragraph) => {
      const readableParagraph = paragraph.cloneNode(true);
      readableParagraph.querySelectorAll('br').forEach((breakElement) => {
        breakElement.replaceWith('\n');
      });
      const lines = readableParagraph.textContent
        .split(/\n+/)
        .map((line) => line.replace(/\u00a0/g, ' ').trim())
        .filter(Boolean);
      const isFactsParagraph = lines.length > 1 && lines.some((line) =>
        factLabels.some((label) => line.startsWith(label))
      );
      if (!isFactsParagraph) return;
      const list = document.createElement('ul');
      list.className = 'product-description__facts';
      lines.filter((line) => !emptyLabels.includes(line)).forEach((line) => {
        const item = document.createElement('li');
        item.textContent = line;
        list.appendChild(item);
      });
      paragraph.replaceWith(list);
    });
  }

  function initializeProductFacts() {
    cleanProductFacts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductFacts);
  } else {
    initializeProductFacts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    cleanProductFacts(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
